<template>
  <b-card id="card-loading" class="m-0 p-0">
    <b-alert
      :show="true"
      variant="warning"
      dismissible
      fade
      class="m-0"
      style="padding: 0.5rem"
    >
      <strong class="my-6 mx-auto">
        Do not close this tab or refresh this page while the interview is in
        progress. </strong
      ><br />
      <small
        >Please proceed with all steps to complete the whole interview.</small
      >
    </b-alert>

    <!-- @on-complete="formSubmitted" -->
    <div class="">
      <b-overlay :show="isLoading" rounded="sm">
        <form-wizard
          id="form-with-loading"
          ref="wizard"
          color="#FF9F43"
          class="m-0"
          :title="null"
          :subtitle="null"
          finish-button-text="Submit"
        >
          <tab-content
            :title="admin ? 'Current candidate' : 'Current employer'"
            class="m-0 p-0"
            :before-change="selectApplicants"
          >
            <b-modal
              v-model="popupList"
              centered
              hide-footer
              title="Incomplete Profile"
            >
              <b-row class="mt-2 mx-auto">
                <h6>
                  Please complete your profile before the interview starts.
                </h6>
              </b-row>

              <b-row class="mt-2 mx-auto">
                <b-button to="/profile" variant="warning" type="filled"
                  >Finish Profile</b-button
                >
              </b-row>
            </b-modal>

            <div class="d-flex justify-content-between">
              <div v-if="!video_call" class="w-100">
                <b-row v-if="admin" class="w-100 m-0 p-0">
                  <b-col cols="12" md="10" class="m-0 p-0">
                    <b-row>
                      <b-col
                        cols="12"
                        md="4"
                        class="flex-fill d-flex flex-column justify-content-start"
                        style="min-width: 33%"
                      >
                        <h6 class="mt-0 pt-0 w-100 font-weight-bolder">
                          1. Select Event (Optional)
                        </h6>

                        <v-select
                          v-model="selected_event_id"
                          placeholder="Select an Event"
                          :options="eventOptions"
                          class="w-100"
                          label="text"
                          :reduce="(option) => option.value"
                        >
                          <template #selected-option="option">
                            <div
                              class="d-flex flex-row flex-gap-md align-items-center"
                            >
                              <img
                                class="banner_image-size"
                                :src="
                                  option.details.banner_image
                                    ? option.details.banner_image_url
                                    : defaultBannerImage
                                "
                              />

                              <div>
                                <b>{{ option.text }}</b>
                                <div v-if="$isNotEmpty(option.details)">
                                  {{ option.details.start_datetime }} -
                                  {{ option.details.end_datetime }}
                                </div>
                              </div>
                            </div>
                          </template>

                          <template #option="option">
                            <div
                              class="d-flex flex-row flex-gap-md align-items-center"
                            >
                              <img
                                class="banner_image-size"
                                :src="
                                  option.details.banner_image
                                    ? option.details.banner_image_url
                                    : defaultBannerImage
                                "
                              />

                              <div>
                                <b>{{ option.text }}</b>
                                <div v-if="$isNotEmpty(option.details)">
                                  {{ option.details.start_datetime }} -
                                  {{ option.details.end_datetime }}
                                </div>
                              </div>
                            </div>
                          </template>
                        </v-select>
                      </b-col>

                      <b-col
                        cols="12"
                        md="4"
                        class="d-flex flex-column justify-content-start"
                        style="min-width: 33%"
                      >
                        <h6 class="mt-0 pt-0 w-100 font-weight-bolder">
                          2. Select a Job / Position
                        </h6>

                        <v-select
                          v-model="selected_job_id"
                          placeholder="Select a position to start an interview"
                          :options="jobOptions"
                          class="w-100"
                          label="text"
                          :reduce="(option) => option.value"
                        >
                          <template #selected-option="option">
                            <div class="d-flex flex-column">
                              <b v-if="selected_event_id == 'all_jobs'">{{
                                $ifPropertyExist(
                                  option,
                                  "details.event.name"
                                ) || "-"
                              }}</b>
                              <div>{{ option.text }}</div>
                            </div>
                          </template>

                          <template #option="option">
                            <div class="d-flex flex-column">
                              <b v-if="selected_event_id == 'all_jobs'">{{
                                $ifPropertyExist(
                                  option,
                                  "details.event.name"
                                ) || "-"
                              }}</b>
                              <div>{{ option.text }}</div>
                            </div>
                          </template>
                        </v-select>
                      </b-col>

                      <b-col
                        cols="12"
                        md="4"
                        v-if="admin == true && video_call == false"
                        class="d-flex flex-column flex-gap-md"
                      >
                        <h6 class="mt-0 pt-0 w-100 font-weight-bolder">
                          3. Click to select an applicant
                        </h6>

                        <div class="d-flex flex-column">
                          <b-avatar-group>
                            <div
                              class="w-100 d-flex flex-row flex-wrap flex-gap-sm overflow-auto"
                              style="height: 7.5rem"
                            >
                              <template v-if="$isNotEmpty(all_applicants)">
                                <div
                                  v-for="(details, userIndex) in all_applicants"
                                  :key="userIndex"
                                >
                                  <div
                                    @click="
                                      changeCurrentInterviewee(
                                        details,
                                        userIndex
                                      )
                                    "
                                  >
                                    <!-- v-if="details.profile_image !== 'default'" -->
                                    <b-avatar
                                      v-b-tooltip.hover.bottom.left="
                                        `${details.fullname} is currently ${
                                          online_users.includes(
                                            details.email_address
                                          )
                                            ? 'online'
                                            : 'offline'
                                        }. Click here to change the current user you want to interview to ${
                                          details.fullname
                                        }.`
                                      "
                                      :title="details.fullname"
                                      :class="
                                        online_users.includes(
                                          details.email_address
                                        )
                                          ? 'bg-success'
                                          : 'bg-danger'
                                      "
                                      class="bg-lighten-4"
                                      :src="
                                        $isEmpty(details.profile_image_url)
                                          ? require('@/assets/images/placeholder/no-image.jpg')
                                          : details.profile_image_url
                                      "
                                      style="
                                        width: 3rem;
                                        height: 3rem;
                                        padding: 3px;
                                      "
                                    />

                                    <!-- <b-avatar
                                      v-else
                                      v-b-tooltip.hover.top="
                                        `${details.fullname} is currently ${
                                          online_users.includes(details.email)
                                            ? 'online'
                                            : 'offline'
                                        }. Click here to change the current user you want to interview to ${
                                          details.fullname
                                        }.`
                                      "
                                      :variant="
                                        online_users.includes(details.email)
                                          ? 'success'
                                          : 'danger'
                                      "
                                      :title="details.fullname"
                                      size="lg"
                                      class="border-2 border-white border-solid primary"
                                      :text="details.email"
                                      @click="changeCurrentInterviewee(details, userIndex)"
                                    /> -->
                                  </div>
                                </div>
                              </template>

                              <template v-else>
                                <div
                                  class="h-100 w-100 d-flex align-items-center justify-content-center"
                                >
                                  No invited Applicant(s)
                                </div>
                              </template>
                            </div>
                          </b-avatar-group>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col cols="12" md="2" class="m-0 p-0">
                    <div
                      class="h-100 d-flex flex-column flex-gap-md justify-content-between"
                      style="padding-inline: 0.5rem"
                    >
                      <b-button
                        variant="success"
                        rounded
                        :disabled="!show_section.start_interview_button"
                        class="h-100 d-flex flex-row flex-wrap flex-gap-lg align-items-center justify-content-center"
                        style="padding: 1rem"
                        @click="requestVideoCall"
                      >
                        <feather-icon
                          icon="PlayIcon"
                          size="65"
                          class="font-weight-bolder"
                        />

                        <p
                          class="m-0 p-0 font-weight-bolder"
                          style="font-size: 1.6rem"
                        >
                          Start Interview
                        </p>
                      </b-button>
                    </div>
                  </b-col>
                </b-row>

                <b-row v-else class="m-0 p-0">
                  <b-button
                    variant="success"
                    rounded
                    class="h-100 d-flex flex-row flex-wrap flex-gap-lg align-items-center justify-content-center"
                    style="padding: 1rem"
                    @click="acceptVideoCall"
                  >
                    <feather-icon
                      icon="PlayIcon"
                      size="65"
                      class="font-weight-bolder"
                    />

                    <p
                      class="m-0 p-0 font-weight-bolder"
                      style="font-size: 1.6rem"
                    >
                      Accept Interview
                    </p>
                  </b-button>
                </b-row>
              </div>

              <div v-else>
                <div v-if="admin == true">
                  <b-button
                    v-if="Object.keys(applicant_details).length > 0"
                    variant="danger"
                    rounded
                    class="h-100 d-flex flex-row flex-wrap flex-gap-lg align-items-center justify-content-center"
                    style="padding: 1rem"
                    @click="endInterview"
                  >
                    <feather-icon
                      icon="PauseIcon"
                      size="65"
                      class="font-weight-bolder"
                    />

                    <p
                      class="m-0 p-0 font-weight-bolder"
                      style="font-size: 1.6rem"
                    >
                      End Interview
                    </p>
                  </b-button>
                </div>
              </div>

              <div
                v-if="
                  (selected_job &&
                    selected_job.event_type === 'speed_interview') ||
                  (event_details &&
                    event_details.event_type === 'speed_interview')
                "
                class="flex"
              >
                <countdown
                  ref="countdown"
                  :auto-start="auto_start"
                  :time="1 * 1 * minutes * 60 * 1000"
                >
                  <template slot-scope="props">
                    <h5
                      :style="
                        props.minutes < 3
                          ? 'color:red;'
                          : 'color: rgb(40, 199, 111);'
                      "
                    >
                      Time remaining:
                      {{ props.minutes.toString().length == 1 ? "0" : ""
                      }}{{ props.minutes }}:{{
                        props.seconds.toString().length == 1 ? "0" : ""
                      }}{{ props.seconds }}
                    </h5>
                  </template>
                </countdown>
              </div>
            </div>

            <hr />

            <div class="d-flex flex-wrap" style="height: 75vh">
              <b-col
                v-if="video_call == false"
                cols="12"
                md="8"
                class="m-0 p-0"
              >
                <b-card
                  border-variant="dark"
                  bg-variant="transparent"
                  class="shadow-none w-100 m-0 p-0"
                >
                  <div>
                    <img
                      :src="require('@/assets/images/play.png')"
                      alt="Interview Room"
                      style="width: 100%"
                      class="blur-1 interview-overlay"
                    />

                    <div class="card-overlay text-white">
                      <div
                        class="h-100 d-flex flex-column justify-between align-items-center"
                      >
                        <div
                          class="h-100 w-100 p-4 text-center d-flex flex-column justify-content-between align-items-center"
                        >
                          <p
                            v-if="admin == true"
                            class="text-white tracking-wide"
                          >
                            When you are ready to begin the interview with the
                            current <br />candidate, please press the button
                            above or skip to get the next candidate
                          </p>

                          <template v-if="$isNotEmpty(applicant_details)">
                            <div
                              class="border-warning rounded-circle"
                              style="
                                padding: 0.3rem;
                                width: 13rem;
                                height: 13rem;
                              "
                              :class="
                                checkIsUserOnline(
                                  applicant_details.email_address
                                )
                                  ? 'bg-success'
                                  : 'bg-danger'
                              "
                            >
                              <b-avatar
                                class="block"
                                style="padding: 0.2rem"
                                size="100%"
                                :src="
                                  $isEmpty(
                                    applicant_details.details.profile_image_url
                                  )
                                    ? require('@/assets/images/placeholder/no-image.jpg')
                                    : applicant_details.details
                                        .profile_image_url
                                "
                              />
                            </div>

                            <h1 class="text-white font-weight-bolder">
                              {{ applicant_details.fullname }}
                            </h1>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card>
              </b-col>

              <b-col v-else id="conference" cols="12" md="8" class="m-0 p-0">
                <iframe
                  v-if="meetUrl && meetUrl.length > 2"
                  allow="geolocation *; microphone *; camera *; display-capture *; clipboard-read; clipboard-write; web-share; autoplay"
                  allowFullScreen="true"
                  webkitallowfullscreen="true"
                  mozallowfullscreen="true"
                  sandbox="allow-same-origin allow-scripts allow-modals allow-forms"
                  style="width: 100%; height: 100%; border: 0"
                  scrolling="no"
                  :src="meetUrl"
                  @load="iframeLoadHelper"
                />
              </b-col>

              <b-col v-if="admin == true" cols="12" md="4" class="p-0 m-0">
                <div style="height: 70vh" class="p-0 m-0 overflow-auto">
                  <b-row
                    v-if="$isEmpty(applicant_details.details)"
                    class="my-auto"
                  >
                    <h6 class="my-auto">
                      {{ applicant_details.details }}
                      There are no pending candidates to interview.
                    </h6>
                  </b-row>

                  <div v-else>
                    <div class="" v-if="!$isEmpty(applicant_details.details)">
                      <b-row class="m-0 p-0">
                        <h5 class="mx-2 mt-0 pt-0 font-weight-bolder">
                          Applicant Details
                        </h5>
                      </b-row>

                      <hr />

                      <b-row class="m-0 p-0">
                        <div class="d-flex flex-row pl-2">
                          <b-avatar
                            class="mx-1 block"
                            size="40px"
                            :src="
                              $isEmpty(
                                applicant_details.details.profile_image_url
                              )
                                ? require('@/assets/images/placeholder/no-image.jpg')
                                : applicant_details.details.profile_image_url
                            "
                          />
                          <div>
                            <div class="">
                              <!-- {{ applicant_details.details.fullname }} -->
                              {{ applicant_details.fullname }}
                            </div>
                            <div
                              v-if="
                                online_users.includes(
                                  applicant_details.details.email_address
                                )
                              "
                              class="text-success"
                            >
                              (Online)
                            </div>
                            <div v-else class="text-danger">(Offline)</div>
                          </div>
                        </div>
                      </b-row>

                      <b-row class="m-0 p-0 mt-1">
                        <h5 class="mx-2 font-weight-bolder">
                          Education Details
                        </h5>
                      </b-row>

                      <hr />

                      <div
                        v-if="!$isEmpty(applicant_details.details.educations)"
                        class=""
                      >
                        <div
                          v-for="(info, index) in applicant_details.details
                            .educations"
                          :key="index"
                        >
                          <div class="mt-1">
                            <div class="d-flex justify-content-between">
                              <b-col v-if="info.school_img" cols="2">
                                <b-avatar
                                  class="mx-2 mb-6 block"
                                  size="60px"
                                  :src="
                                    info.school_img == 'default'
                                      ? require('@/assets/images/placeholder/no-image.jpg')
                                      : info.school_img
                                  "
                                />
                              </b-col>
                              <b-col
                                cols="10"
                                class="ml-2 w-75"
                                :class="info.school_img ? 'w-75' : 'w-100'"
                              >
                                <b-row>
                                  <h6 class="underline">
                                    <u class="font-weight-bolder">{{
                                      info.school_name
                                    }}</u>
                                  </h6>
                                </b-row>
                                <b-row>
                                  <span>{{ info.field_of_study }}</span>
                                </b-row>
                                <b-row>
                                  <span
                                    >{{ info.start_date }} -
                                    {{ info.end_date }}</span
                                  >
                                </b-row>
                              </b-col>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else class="mb-3">
                        <span
                          >No education details available for this
                          applicant.</span
                        >
                      </div>

                      <b-row class="m-0 p-0 mt-1">
                        <h5 class="mx-1 font-weight-bolder">
                          Employment Details
                        </h5>
                      </b-row>

                      <hr />

                      <div
                        v-if="!$isEmpty(applicant_details.details.employments)"
                        class=""
                      >
                        <div
                          v-for="(info, index) in applicant_details.details
                            .employments"
                          :key="index"
                        >
                          <div class="mt-1">
                            <div class="d-flex justify-content-between">
                              <b-col
                                v-if="info.company_img"
                                cols="2"
                                class="vx-col md:w-1/4"
                              >
                                <b-avatar
                                  class="mx-2 mb-6 block"
                                  size="60px"
                                  :src="
                                    info.company_img == 'default'
                                      ? require('@/assets/images/placeholder/no-image.jpg')
                                      : info.company_img
                                  "
                                />
                              </b-col>
                              <b-col
                                cols="10"
                                class="ml-2 w-75"
                                :class="info.company_img ? 'w-75' : 'w-100'"
                              >
                                <b-row>
                                  <h6 class="underline">
                                    <u class="font-weight-bolder">{{
                                      info.position
                                    }}</u>
                                  </h6>
                                </b-row>
                                <b-row>
                                  <span> {{ info.company_name }}</span>
                                </b-row>
                                <b-row>
                                  <span
                                    >{{ info.start_date }} -
                                    {{ info.end_date }}</span
                                  >
                                </b-row>
                              </b-col>
                            </div>
                            <b-row class="ml-2">
                              {{ info.description }}
                            </b-row>
                          </div>
                        </div>
                      </div>
                      <div v-else class="mb-2">
                        <span
                          >No employment details available for this
                          applicant.</span
                        >
                      </div>

                      <b-row
                        v-if="
                          !$isEmpty(
                            Object.keys(applicant_details.answers || {})
                          )
                        "
                        class="m-0 p-0 mt-1"
                      >
                        <h5 class="mx-1 font-weight-bolder">
                          Screening Questions
                        </h5>
                      </b-row>
                      <hr
                        v-if="
                          !$isEmpty(
                            Object.keys(applicant_details.answers || {})
                          )
                        "
                      />
                      <b-row
                        v-if="
                          !$isEmpty(
                            Object.keys(applicant_details.answers || {})
                          )
                        "
                        class="m-0 p-0 pl-2"
                      >
                        <p
                          v-for="(
                            value, index, propertyName
                          ) in applicant_details.answers"
                          :key="index"
                          class="w-100"
                        >
                          {{ index + 1 }}. {{ value.question }}:
                          <b>{{ value.answer }}</b>
                        </p>
                      </b-row>
                    </div>
                  </div>
                </div>
              </b-col>

              <b-col v-else cols="12" md="4" class="">
                <b-card style="overflow-y: scroll; height: 70vh">
                  <b-row v-if="$isEmpty(event_details)" class="vx-row">
                    <h5>You are done with all interviews.</h5>
                  </b-row>

                  <div v-else>
                    <InterviewDetails :details="event_details" />
                  </div>
                </b-card>
              </b-col>
            </div>

            <!-- <b-row v-if="admin == true" cols="12" class="mx-2 my-1"> -->
            <b-row v-if="false" cols="12" class="mx-2 my-1">
              <b-form-textarea
                v-model="feedback"
                placeholder="Candidate Feedback"
                rows="3"
                class="w-100"
              />
            </b-row>

            <template v-if="false">
              <div
                v-if="admin == true && video_call == false"
                class="d-flex flex-row ml-1"
              >
                <div class="mt-1 mr-1">
                  <h6 class="">Online Applicants:</h6>
                </div>
                <div class="d-flex flex-column">
                  <b-avatar-group>
                    <div
                      v-for="(details, userIndex) in all_applicants"
                      :key="userIndex"
                    >
                      <div
                        @click="changeCurrentInterviewee(details, userIndex)"
                      >
                        <!-- v-if="details.profile_image !== 'default'" -->
                        <b-avatar
                          v-b-tooltip.hover.top="
                            `${details.fullname} is currently ${
                              online_users.includes(details.email_address)
                                ? 'online'
                                : 'offline'
                            }. Click here to change the current user you want to interview to ${
                              details.fullname
                            }.`
                          "
                          :title="details.fullname"
                          :class="
                            online_users.includes(details.email_address)
                              ? 'border-success'
                              : 'border-danger'
                          "
                          :src="
                            $isEmpty(details.profile_image_url)
                              ? require('@/assets/images/placeholder/no-image.jpg')
                              : details.profile_image_url
                          "
                          class="border-2 border-white border-solid"
                          style="width: 48px; height: 48px"
                        />

                        <!-- <b-avatar
                          v-else
                          v-b-tooltip.hover.top="
                            `${details.fullname} is currently ${
                              online_users.includes(details.email)
                                ? 'online'
                                : 'offline'
                            }. Click here to change the current user you want to interview to ${
                              details.fullname
                            }.`
                          "
                          :variant="
                            online_users.includes(details.email)
                              ? 'success'
                              : 'danger'
                          "
                          :title="details.fullname"
                          size="lg"
                          class="border-2 border-white border-solid primary"
                          :text="details.email"
                          @click="changeCurrentInterviewee(details, userIndex)"
                        /> -->
                      </div>
                    </div>
                  </b-avatar-group>
                </div>
              </div>
            </template>
          </tab-content>

          <!-- tab 3 content -->
          <tab-content
            :title="
              admin
                ? 'Please rate the current candidate before proceeding to the next'
                : 'Rate your experience with the employer'
            "
            class="mb-1"
          >
            <b-row v-if="admin" class="mt-1 mb-1">
              <h4 v-if="applicant_details.details" class="ml-1">
                What do you think of {{ applicant_details.details.fullname }}?
              </h4>
            </b-row>

            <div v-else class="d-flex mt-1 mb-1 mx-auto">
              <b-col class="mx-auto">
                <h4 class="mx-auto">How was your interview experience?</h4>
                <star-rating
                  v-model="applicant_rating"
                  class="mx-auto"
                  :increment="0.5"
                  :star-size="30"
                />
              </b-col>
            </div>

            <b-row class="vx-row">
              <b-col v-if="admin" cols="12" md="3">
                <h6 class="mt-1">Attitude</h6>
                <star-rating
                  v-model="attitude"
                  :increment="0.5"
                  :star-size="30"
                />
                <h6 class="mt-1">Communication</h6>
                <star-rating
                  v-model="communication"
                  :increment="0.5"
                  :star-size="30"
                />
                <h6 class="mt-1">Cultural Fit</h6>
                <star-rating
                  v-model="culture"
                  :increment="0.5"
                  :star-size="30"
                />
                <h6 class="mt-1">Experience</h6>
                <star-rating
                  v-model="experience"
                  :increment="0.5"
                  :star-size="30"
                />
                <h6 class="mt-1">Skills and Knowledge</h6>
                <star-rating
                  v-model="skills"
                  :increment="0.5"
                  :star-size="30"
                />
              </b-col>

              <b-col cols="12" md="9">
                <b-row v-if="admin" class="vx-row mx-1 mt-2">
                  <v-select
                    v-model="selected_application_status"
                    placeholder="Choose the application status"
                    class="w-100"
                    :options="application_statuses"
                    label="value"
                    :reduce="(value) => value.value"
                  />
                </b-row>
                <b-row class="vx-row mx-1 mt-2">
                  <b-form-textarea
                    v-model="feedback"
                    :placeholder="
                      admin ? 'Candidate Feedback' : 'Your feedback'
                    "
                    rows="8"
                    class="w-full"
                  />
                </b-row>

                <b-button
                  class="mx-1 mt-2"
                  variant="success"
                  @click="afterFeedback"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </tab-content>
          <template slot="footer" slot-scope="props">
            <div class="wizard-footer-left" />
            <div class="wizard-footer-right" />
          </template>
        </form-wizard>
      </b-overlay>
    </div>
    <ProfileCompletionForm
      :activate-popup="popupProfileQuestions"
      :hide-header="true"
      @open-completion-form="activateTypeForm"
    />
  </b-card>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard"

import { completionMixins } from "@/components/mixins/CompletionMixins"

import StarRating from "vue-star-rating"
import BigBlueButtonApi from "bigbluebutton-js"
import VSelect from "vue-select"
import "vue-form-wizard/dist/vue-form-wizard.min.css"
import useJwt from "@/auth/jwt/useJwt"
import {
  BCard,
  BFormTextarea,
  BFormInput,
  BButton,
  BRow,
  BCol,
  BInputGroup,
  BInputGroupAppend,
  BModal,
  VBModal,
  VBTooltip,
  BBadge,
  BAvatar,
  BOverlay,
  BFormCheckbox,
  BFormInvalidFeedback,
  BAvatarGroup,
} from "bootstrap-vue"
import axios from "axios"

import InterviewDetails from "./components/interview-room/InterviewDetails.vue"

export default {
  components: {
    VSelect,
    BCard,
    BFormTextarea,
    BFormInput,
    BAvatarGroup,
    BButton,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    BModal,
    VBModal,
    BBadge,
    BAvatar,
    BOverlay,
    BFormCheckbox,
    BFormInvalidFeedback,
    FormWizard,
    TabContent,
    StarRating,

    InterviewDetails,
  },
  directives: {
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
  },
  mixins: [completionMixins],
  data() {
    return {
      axios,

      eventOptions: [{ text: "All Jobs", value: "all_jobs", details: {} }],
      defaultBannerImage: require("@/assets/images/placeholder/no-image.jpg"),

      jobOptions: [{ text: null, value: null, details: { event: {} } }],

      interview_in_progress: [],
      event_id: "",
      all_events: [],
      selected_event_id: "all_jobs",
      selected_job_id: null,
      event_date: "XXXX-XX-XX",
      popupList: false,
      incomplete: false,
      all_event_ids: [],
      attitude: 0,
      communication: 0,
      culture: 0,
      experience: 0,
      skills: 0,
      event_details: {},
      employer_details: {},
      feedback: "",
      approved: "pending",
      online_users: [],
      video_call: false,
      all_applicants: [],
      selected_job: [],
      applicant_details: {},
      already_checked: [],
      skipped: [],
      admin: false,
      show_section: {
        start_interview_button: false,
      },
      times_up: false,
      roomname: "",
      email_address: "",
      fullname: "",
      time: "",
      wordString: {},
      start: "",
      end: "",
      interval: "",
      minutes: "08",
      seconds: "00",
      isRunning: false,
      auto_start: false,
      message: "",
      statusType: "",
      statusText: "",
      timer_checker: "",
      timer_data: { applicant: false, employer: false },
      application_statuses: [
        { text: "Hired", value: "Hired" },
        { text: "Shortlisted", value: "Shortlisted" },
        { text: "Kept In View", value: "Kept In View" },
        { text: "Rejected", value: "Rejected" },
      ],
      selected_application_status: "",
      bbbUrl: "https://conference.headhuntershq.com/bigbluebutton",
      bbbSecret: "olxExVRsAj77w1sNU3B1GlIyeJUKlXFVr07dnWUyj4k",
      bbbAPI: null,
      meetUrl: "",
      meetEndUrl: "",
      isLoading: true,
      applicant_rating: null,
    }
  },
  computed: {
    getToolTipText(details) {
      const current_status = this.online_users.includes(details.email)
        ? "online"
        : "offline"
      return `${details.fullname} is currently ${current_status}. Click here to change the current user you want to interview to .`
    },
    extractInitials(email) {
      return email.splice(0, 3).toUpperCase()
    },

    jitsiOptions() {
      return {
        roomName: this.roomname,
        noSSL: false,
        userInfo: {
          email_address: this.email_address,
          displayName: this.fullname,
        },
        configOverwrite: {
          disableDeepLinking: true,
          enableNoisyMicDetection: false,
          enableWelcomePage: false,
          noticeMessage: "",
          prejoinPageEnabled: false,
          subject: this.roomname,
        },
        interfaceConfigOverwrite: {
          APP_NAME: "HeadHunters HQ Interview Event",
          SHOW_JITSI_WATERMARK: false,
          SHOW_WATERMARK_FOR_GUESTS: false,
          SHOW_CHROME_EXTENSION_BANNER: false,
          DISPLAY_WELCOME_PAGE_CONTENT: false,
          MOBILE_APP_PROMO: false,
          TOOLBAR_BUTTONS: [
            "microphone",
            "camera",
            "closedcaptions",
            "desktop",
            "fullscreen",
            "fodeviceselection",

            "profile",
            "chat",
            "recording",
            "videoquality",
            "filmstrip",
            "tileview",
            "videobackgroundblur",
            "download",
            "mute-everyone",
          ],

          DEFAULT_BACKGROUND: "#474747",
          DEFAULT_LOCAL_DISPLAY_NAME: "HeadHunters HQ ",
          DEFAULT_LOGO_URL:
            "https://i.ibb.co/4wyDnbs/Head-Hunters-HQ-Icon-Transparent-Background.png",
          DEFAULT_REMOTE_DISPLAY_NAME: "",
          DEFAULT_WELCOME_PAGE_LOGO_URL:
            "https://i.ibb.co/4wyDnbs/Head-Hunters-HQ-Icon-Transparent-Background.png",
        },
        onload: this.onIFrameLoad,
      }
    },
  },
  watch: {
    selected_event_id(val) {
      // this.getMatch();
      if (this.admin) {
        localStorage.setItem("selected_event_id", val)
        this.getJobOptions()
      }
    },

    selected_job_id(val) {
      // this.getMatch();
      if (this.admin) {
        if (this.$isNotEmpty(val)) {
          localStorage.setItem("selected_job_id", val)
          this.getApplicants()
        }
      }
    },

    online_users(val) {
      this.checkIsUserOnline(this.applicant_details.email_address)
    },
  },
  mounted() {
    const incompleteProfile = this.checkProfileCompletion()

    if (incompleteProfile) {
      this.popupProfileQuestions = true
    }

    this.online_users = this.$store.state.auth.online_users
    this.$socket.client.on("all_online_users", (data) => {
      this.online_users = data.data
      if (this.online_users === undefined) {
        this.online_users = []
      }
    })

    this.$socket.client.emit(
      "check_reconnect",
      this.$store.state.auth.ActiveUser.email_address
    )
    this.$socket.client.on("check_reconnect", (data) => {
      if (this.$isNotEmpty(data.data)) {
        // TODO: reconnect to the first room found for now, in the future could add feature to let user select which room to reconnect
        const meeting_details = Object.values(data.data)[0]
        this.video_call = true

        this.meetUrl = meeting_details.meeting_url
        this.meetUrl = this.$addParamsToExternalUrl(
          this.meetUrl,
          "name",
          this.$store.state.auth.ActiveUser.fullname
        )
        // this.meetUrl = this.$addParamsToExternalUrl(this.meetUrl, 'notify', 0)
        // this.meetUrl = this.$addParamsToExternalUrl(this.meetUrl, 'duration', '00:30:00')

        this.selected_job = meeting_details.job_details
        this.applicant_details = meeting_details.applicant_details

        this.isLoading = false
      }
    })

    this.$socket.client.on("interviewer_link", (data) => {
      if (this.admin) {
        this.meetUrl = data.data.interviewer_link
        this.meetUrl = this.$addParamsToExternalUrl(
          this.meetUrl,
          "name",
          this.$store.state.auth.ActiveUser.fullname
        )

        this.meetEndUrl = data.data.meeting_end_link

        this.$store.commit(
          "auth/UPDATE_MEETING_END_LINK",
          data.data.meeting_end_link
        )
        this.$store.commit(
          "auth/UPDATE_INTERVIEWER_LINK",
          data.data.interviewer_link
        )

        this.isLoading = false
      }
    })

    this.$socket.client.on("interview_in_progress", (data) => {
      this.interview_in_progress = data.data
    })

    this.$socket.client.on("received_video_call_requests", (data) => {
      if (data) {
        this.receivedVideoCall(data)
      }
    })

    this.$socket.client.on("end_interview_applicant", (data) => {
      const current_email = this.$store.state.auth.ActiveUser.email_address
      const { applicant_details } = data
      if (current_email === applicant_details.email_address) {
        localStorage.removeItem("interview_running")
        // this.event_details = []
        // this.$refs.wizard.reset()
        this.$refs.wizard.nextTab()
      }
    })

    this.$socket.client.on("start_interview_employer", (data) => {
      this.sendAcceptanceRequest(data)
    })

    this.$socket.client.on(
      `session_check_response-${localStorage.getItem("tracking_id")}`,
      (response) => {
        if (response.output.status === "session_ended") {
          this.$http
            .post(`/api/auth/logout`, {
              access_token: localStorage.getItem(
                useJwt.jwtConfig.storageTokenKeyName
              ),
              tracking_id: localStorage.getItem("tracking_id"),
              logout_other_sessions: false,
            })
            .then((response) => {
              this.$store.commit("auth/UPDATE_USER_INFO", null, { root: true })
              localStorage.removeItem("userInfo")
              localStorage.removeItem("email")
              localStorage.removeItem("tracking_id")
              localStorage.setItem("tracking_id", this.$generateUUID4())
              localStorage.removeItem("accessToken")
              localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
              delete this.$http.defaults.headers.common["Authorization"]
              this.$toastWarning("Session Ended")

              setTimeout(() => {
                if (!this.$router.currentRoute.meta.allowAnonymous) {
                  this.$router.push({ name: "auth-login" })
                }
              }, 100)
            })
            .catch((error) => {
              this.$handleErorResponse(error)
              this.isLoading = false
            })
        }
      }
    )

    const auth = this.$store.state.auth.ActiveUser.user_group

    this.admin = auth.includes("admin")
    this.selected_event_id = localStorage.getItem("selected_event_id") || null
    this.selected_job_id = localStorage.getItem("selected_job_id") || null

    const interview_details = JSON.parse(
      localStorage.getItem("interview_running")
    )

    const { incoming_interview } = this.$store.state

    if (incoming_interview) {
      if (!this.admin && !interview_details) {
        this.receivedVideoCall(incoming_interview)
      }
    }
    this.$nextTick(function () {
      if (interview_details) {
        const { email_address, fullname } = this.$store.state.auth.ActiveUser

        this.email_address = email_address

        this.fullname = fullname
        this.event_details = interview_details.event_details
        this.applicant_details = interview_details.applicant_details
        this.roomname = interview_details.roomname
        this.video_call = true

        this.$toastSuccess(
          "Interview notification",
          "Reconnecting you to the previous interview session."
        )

        if (this.admin) {
          this.meetUrl = this.$store.state.interviewer_link
            ? this.$store.state.interviewer_link
            : localStorage.getItem("interviewer_link")

          this.meetUrl = this.$addParamsToExternalUrl(
            this.meetUrl,
            "name",
            this.$store.state.auth.ActiveUser.fullname
          )
        } else {
          this.meetUrl = this.$store.state.applicant_link
            ? this.$store.state.applicant_link
            : localStorage.getItem("applicant_link")

          this.meetUrl = this.$addParamsToExternalUrl(
            this.meetUrl,
            "name",
            this.$store.state.auth.ActiveUser.fullname
          )
        }
        if (this.meetUrl) {
          this.isLoading = false
        }
      } else if (this.admin) {
        this.getAllEvents()
      } else {
        if (!incoming_interview) {
          this.isLoading = true
        }

        this.$toastSuccess(
          "Interview notification",
          "Waiting for an employer to request an interview with you."
        )
      }

      if (localStorage.getItem("countdown_minutes")) {
        this.minutes = localStorage.getItem("countdown_minutes")
        this.seconds = localStorage.getItem("countdown_seconds")
        if (this.seconds) {
          this.auto_start = false
        } else {
          this.auto_start = true
        }
      }
    })

    const { booking_id } = this.$route.params
    if (booking_id) {
      localStorage.removeItem("interview_running")
      this.$http
        .get(`/api/booking/${booking_id}`)
        .then((response) => {
          const { output } = response.data
          const { success } = response.data

          if (success) {
            const { company_name } = this.$store.state.auth.ActiveUser
            this.applicant_details = {}
            this.applicant_details.booking_id = booking_id
            this.times_up = true
            this.$refs.wizard.changeTab(0, 1)
          } else {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: "Invalid Booking",
                  icon: "AlertCircleIcon",
                  text: "Could not get the applicants details.",
                  variant: "danger",
                },
              },
              { timeout: this.$longestTimeout }
            )
            this.$router.push("/events-manager/rooms")
          }
        })
        .catch((error) => {})
    }

    this.getEventsOptions()
  },
  created() {
    this.online_users = this.$store.state.auth.ActiveUser.online_users
    if (this.online_users === undefined) {
      this.online_users = []
    }
    this.bbbAPI = BigBlueButtonApi.api(this.bbbUrl, this.bbbSecret)
  },
  methods: {
    getEventsOptions() {
      let params = { query: "" }
      let query = `?params=${JSON.stringify(params)}`

      this.$http
        .get(`/api/event-options${query}`)
        .then((response) => {
          const { success, output, message } = response.data

          if (success) {
            this.eventOptions = output.sort((a, b) =>
              a.text.localeCompare(b.text)
            )

            let foundEventId = false
            this.eventOptions.forEach(v => {
              if (v.value == this.selected_event_id) {
                foundEventId = true
              }
            })
            if (!foundEventId) {
              localStorage.removeItem("selected_event_id")
              this.selected_event_id = 'all_jobs'
            }

            this.eventOptions.unshift({
              text: "All Jobs",
              value: "all_jobs",
              details: {},
            })
          }
          this.getJobOptions()
        })
        .then((response) => {
          //
        })
        .catch(() => {

        })
    },

    getJobOptions() {
      const event_id =
        this.selected_event_id == "all_jobs" ? null : this.selected_event_id
      let params = { event_id: event_id }
      let query = `?params=${JSON.stringify(params)}`

      this.$http
        .get(`/api/job-options${query}`)
        .then((response) => {
          const { success, output, message } = response.data

          if (success) {
            if (this.$isNotEmpty(output)) {
              this.jobOptions = output.sort((a, b) =>
                a.text.localeCompare(b.text)
              )

              if (this.selected_event_id == "all_jobs") {
                this.jobOptions = output.sort((a, b) => {
                  const x = a.details.event.name || ""
                  const y = b.details.event.name || ""
                  return x.localeCompare(y)
                })
              }

              let foundJobId = false
              this.jobOptions.forEach(v => {
                if (v.value == this.selected_job_id) {
                  foundJobId = true
                }
              })
              if (!foundJobId) {
                localStorage.removeItem("selected_job_id")
                this.selected_job_id = null
              }
            } else {
              this.jobOptions = []
              this.selected_job_id = null
            }
          } else {
            this.jobOptions = []
            this.selected_job_id = null
          }
        })
        .then((response) => {
          //
        })
        .catch(error => {
          //
        })
    },

    createMeetUrl() {
      this.$http
        .get(
          `/api/interview-rooms/${this.applicant_details.booking_id}/meeting-link`
        )
        .then((response) => {
          const { success, output } = response.data
          this.meetUrl = output.meeting
          const meetUrlParts = this.meetUrl.split("/")
          this.meetUrl = this.$addParamsToExternalUrl(
            this.meetUrl,
            "name",
            this.$store.state.auth.ActiveUser.fullname
          )
          this.$store.commit("auth/UPDATE_APPLICANT_LINK", output.meeting)
          this.$socket.client.emit("interviewer_link", {
            interviewer_link: output.meeting,
            meeting_end_link: output.meeting,
            id: this.applicant_details.booking_id,
          })

          const applicationIdList = this.event_details.job_applications.filter(
            (job_application) => {
              return (
                job_application.applicant_id ===
                this.$store.state.auth.ActiveUser.id
              )
            }
          )
          const applicationId = applicationIdList[0]

          // need to get application id
          this.$http.put(`/api/update-meeting-id/${applicationId}`, {
            id: meetUrlParts[meetUrlParts.length - 1],
          })
        })
        .catch((error) => {
          //
        })

      // const api = BigBlueButtonApi.api(this.bbbUrl, this.bbbSecret)
      // const { http } = BigBlueButtonApi

      // const moderatorPW = "md-pass"
      // const attendeePW = "a-pass"

      // // api module itself is responsible for constructing URLs
      // const meetingCreateUrl = api.administration.create(
      //   this.roomname,
      //   this.roomname,
      //   {
      //     recordID: this.roomname,
      //     moderatorPW,
      //     attendeePW,
      //     welcome: "Welcome!",
      //     fullName: "Interview Session",
      //     meetingID: this.roomname,
      //     redirect: true,
      //     record: true,
      //     autoStartRecording: true,
      //   }
      // )

      // // http method should be used in order to make calls
      // http(meetingCreateUrl)
      //   .then((result) => {
      //     const moderatorUrl = api.administration.join(
      //       "interviewer",
      //       this.roomname,
      //       moderatorPW
      //     )
      //     const attendeeUrl = api.administration.join(
      //       "applicant",
      //       this.roomname,
      //       attendeePW
      //     )
      //     this.meetUrl = attendeeUrl
      //     // console.log(
      //     //   `Moderator link: ${moderatorUrl}\nAttendee link: ${attendeeUrl}`
      //     // );
      //     const meetingEndUrl = api.administration.end(
      //       this.roomName,
      //       moderatorPW
      //     )
      //     this.$store.commit("auth/UPDATE_APPLICANT_LINK", attendeeUrl)
      //     this.$socket.client.emit("interviewer_link", {
      //       interviewer_link: moderatorUrl,
      //       meeting_end_link: meetingEndUrl,
      //     })
      //   })
      //   .catch((error) => {})
    },
    iframeLoadHelper() {
      if (this.iframeReady) {
        this.isLoading = false
      }
    },
    receivedVideoCall(data) {
      const current_email = this.$store.state.auth.ActiveUser.email_address
      const { applicant_details, job_details } = data

      if (current_email === applicant_details.email_address) {
        this.minutes = job_details.interview_duration
        this.event_details = job_details
        this.applicant_details = applicant_details

        this.$store.dispatch("auth/updateIncomingInterview", {})

        this.isLoading = false
      }
    },
    sendAcceptanceRequest(data) {
      const { applicant_details } = data
      const { event_details } = data
      const current_email = this.$store.state.auth.ActiveUser.email
      this.roomname = applicant_details.booking_id

      if (current_email === event_details.interviewer) {
        this.$toast(
          {
            component: this.$toastContent,
            props: {
              title: "Interview notification",
              icon: "AlertCircleIcon",
              text: "Please wait the applicant will join the interview in a few seconds.",
              variant: "success",
            },
          },
          { timeout: this.$longestTimeout }
        )
        localStorage.setItem(
          "interview_running",
          JSON.stringify({
            applicant_details,
            event_details,
            roomname: this.roomname,
          })
        )
        this.video_call = true
        this.isLoading = false
        // this.setTime(8, 0);
        // this.$refs.countdown.start();
        // this.isLoading = true
      }
    },
    handleCountdownProgress(data) {
      localStorage.setItem("countdown_minutes", data.minutes)
      localStorage.setItem("countdown_seconds", data.seconds)
    },
    changeCurrentInterviewee(details, index) {
      if (details.email_address === this.applicant_details.email_address) {
        this.$toastWarning(
          "Interview Section",
          `You are currently viewing ${details.fullname}. To change the current user, click on the other applicants below the video call screen.`
        )
      } else {
        this.applicant_details = this.all_applicants[index]
        this.$toastWarning(
          "Interview Section",
          `You are now viewing ${details.fullname}.`
        )
      }

      this.checkIsUserOnline(this.applicant_details.email_address)
    },

    checkIsUserOnline(email_address) {
      let is_user_online = false
      if (this.online_users.includes(email_address)) {
        is_user_online = true
        this.show_section.start_interview_button = true
      } else {
        is_user_online = false
        this.show_section.start_interview_button = false
      }

      return is_user_online
    },

    getAllEvents() {
      this.$http
        .get("/api/get_company_events")
        .then((response) => {
          this.all_events = response.data.output
          this.isLoading = false
        })
        .catch((error) => {})
    },
    afterFeedback(payload) {
      let all_data = {}
      const { id } = this.$store.state.auth.ActiveUser || {}
      if (this.admin) {
        const feedback_data = {
          attitude: this.attitude,
          communication: this.communication,
          culture: this.culture,
          experience: this.experience,
          skills: this.skills,
        }

        all_data = {
          booking_id: this.applicant_details.booking_id,
          interviewer_id: id,
          application_status: this.selected_application_status,
          note: this.feedback,
          employer_feedback: this.feedback,
          feedback_data,
          company: this.$store.state.auth.ActiveUser.company_name,
        }
      } else {
        all_data = {
          booking_id: this.applicant_details.booking_id,
          applicant_id: id,
          applicant_feedback: this.feedback,
          applicant_rating: { applicant_rating: this.applicant_rating },
        }
      }

      if (this.feedback) {
        this.$http
          .put("/api/book", { data: all_data })
          .then((response) => {
            if (response.data.success) {
              this.$toast(
                {
                  component: this.$toastContent,
                  props: {
                    title: "Feedback Recorded",
                    icon: "AlertCircleIcon",
                    text: "You may now proceed with your next interview.",
                    variant: "primary",
                  },
                },
                { timeout: this.$longestTimeout }
              ) // this.endInterview();
              // if (this.$router.currentRoute.path !== "/notifications")

              // this.$refs.wizard.reset()
              window.location.reload()
            } else {
              this.$toast(
                {
                  component: this.$toastContent,
                  props: {
                    title: "Feedback Recording Failed",
                    icon: "AlertCircleIcon",
                    text: "We could not update the candidates feedback.",
                    variant: "danger",
                  },
                },
                { timeout: this.$longestTimeout }
              )
              this.$refs.wizard.reset()
              window.location.reload()
            }
          })
          .catch((error) => {})
      } else {
        this.$toast(
          {
            component: this.$toastContent,
            props: {
              title: "Feedback Section",
              icon: "AlertCircleIcon",
              text: "Please fill all fields in the form and star ratings before proceeding.",
              variant: "danger",
            },
          },
          { timeout: this.$longestTimeout }
        )
      }
    },
    acceptVideoCall() {
      const { email_address } = this.$store.state.auth.ActiveUser || {}
      const { fullname } = this.$store.state.auth.ActiveUser || {}
      this.email_address = email_address
      this.fullname = fullname
      this.roomname = this.applicant_details.booking_id

      this.$socket.client.emit("add_to_interview", email_address)
      this.$toastSuccess(
        "Interview notification",
        "Get ready! Interview will being soon"
      )
      this.$socket.client.emit(
        "start_interview_applicant",
        this.event_details,
        this.applicant_details
      )
      localStorage.setItem(
        "interview_running",
        JSON.stringify({
          applicant_details: this.applicant_details,
          event_details: this.event_details,
          roomname: this.roomname,
        })
      )

      this.createMeetUrl()
      this.video_call = true
      // this.setTime(8, 0);
      // this.$refs.countdown.start()
      this.isLoading = true
      const outer_this = this
      setTimeout(() => {
        outer_this.isLoading = false
      }, 2000)
    },
    getApplicants() {
      this.isLoading = true
      const params = { section: "interview_room" }
      let query = `?params=${JSON.stringify(params)}`

      this.$http
        .get(`/api/job-applicants/${this.selected_job_id}${query}`)
        .then((response) => {
          const { success, applicants, job_details } = response.data


          if (!success) {
            // localStorage.removeItem("selected_job_id")
            // this.selected_job_id = null
          } else {
            this.all_applicants = applicants
            this.selected_job = job_details
          }

          if (this.selected_job.event_type === "speed_interview") {
            this.minutes = this.selected_job.interview_duration
          } else {
            this.minutes = ""
          }

          // if (
          //   job_details.active === true ||
          //   (
          //     job_details.closed_on >= new Date() ||
          //     job_details.closed_on === null
          //   ),
          //   this.$isNotEmpty(applicants)
          // ) {
          //   this.show_section.start_interview_button = true
          // } else {
          //   this.show_section.start_interview_button = false
          // }

          if (this.$isNotEmpty(this.all_applicants)) {
            this.applicant_details = this.all_applicants[0]
          } else {
            this.applicant_details = {}
            this.$toastWarning(
              "Interview room notification",
              "There are no candidates to interview."
            )
          }

          this.isLoading = false
        })
        .catch((error) => {
          //
        })
    },

    setTime(minutes, seconds) {
      this.time = minutes * 60 + seconds
    },

    selectApplicants() {
      if (this.times_up) {
        return true
      }
      this.$toast(
        {
          component: this.$toastContent,
          props: {
            title: "Interview notification",
            icon: "AlertCircleIcon",
            text: "You cannot proceed until you finish the interview section.",
            variant: "danger",
          },
        },
        { timeout: this.$longestTimeout }
      )

      return true
    },
    requestVideoCall() {
      if (
        this.interview_in_progress.includes(
          this.applicant_details.email_address
        )
      ) {
        this.$toastDanger(
          "Interview notification",
          `${this.applicant_details.fullname} is currently in another interview room. Please select another applicant or wait until ${this.applicant_details.fullname} is available to initiate the interview process.`
        )
      } else if (
        this.online_users.includes(this.applicant_details.email_address)
      ) {
        const selected_job = { ...this.selected_job }
        selected_job.job_applications = selected_job.job_applications.filter(
          (app) => {
            return app.id == this.applicant_details.id
          }
        )

        this.$socket.client.emit(
          "request_video_call",
          this.applicant_details,
          selected_job,
          this.$store.state.auth.ActiveUser.email_address
        )

        this.$toastSuccess(
          "Interview notification",
          `${this.applicant_details.fullname} has been informed to get ready for the interview. Please wait while they join.`
        )
        this.isLoading = true
      } else {
        this.$toastDanger(
          "Interview notification",
          `${this.applicant_details.fullname} is currently offline. Please select another applicant or wait until ${this.applicant_details.fullname} is back online to initiate the interview process.`
        )
      }
    },
    endInterview() {
      this.times_up = true
      this.video_call = false
      if (this.admin) {
        localStorage.removeItem("interview_running")
        localStorage.removeItem("interviewer_link")
        localStorage.removeItem("meeting_end_link")
        localStorage.removeItem("applicant_link")
        this.$refs.wizard.nextTab()
        this.$socket.client.emit("end_interview", this.applicant_details)

        // const api = BigBlueButtonApi.api(this.bbbUrl, this.bbbSecret)
        // const { http } = BigBlueButtonApi

        // http(this.meetEndUrl).then((response) => {})
      } else {
        localStorage.removeItem("interview_running")
        localStorage.removeItem("interviewer_link")
        localStorage.removeItem("meeting_end_link")
        localStorage.removeItem("applicant_link")
        this.event_details = []
        this.$refs.wizard.nextTab()
      }

      // clearInterval(this.timer);
    },

    setInterviewDuration() {},

    onIFrameLoad() {
      this.isLoading = false
    },
  },
}
</script>
<style lang="css">
.card-overlay {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 0;
}
.interview-overlay {
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
}

.banner_image-size {
  width: 6rem;
  height: auto;
}
</style>
